import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'

import { setAccessToken } from '@/api'

const GoogleCallbackPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const token = Cookies.get('accessToken')
    if (token) {
      setAccessToken(token)
      navigate('/')
    } else {
      navigate('/login')
    }
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center text-center text-gray-700">
      Google authorization...
    </div>
  )
}

export default GoogleCallbackPage
